function getFirstModule({ state, output }) {
  const modules = state.get('client.user.currentClient.modules')
  const firstModule = modules.reduce((acc, module) => {
    if (!acc && module.module !== 'account') {
      acc = module.module
    }
    return acc
  }, null)

  if (firstModule) {
    output.module({ name: firstModule })
  } else {
    output.none()
  }
}

getFirstModule.outputs = ['module', 'none']

export default getFirstModule



// WEBPACK FOOTER //
// ./src/modules/login/actions/getFirstModule.js